module.exports = __webpack_public_path__ + "media/images/contacts/dani-891c70cf13e100eb512403b26ff6cae3.png";